
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test/ab_price_card_usps/variant_c/course/[slug]",
      function () {
        return require("private-next-pages/test/ab_price_card_usps/variant_c/course/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test/ab_price_card_usps/variant_c/course/[slug]"])
      });
    }
  